module.exports = __webpack_public_path__ + "static/media/savills.2b846f7b.png";